import { SVGProps } from "react";

const ArrowRightV2 = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width={20}
    height={21}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.4248 16.9891L12.8581 11.6545C13.4998 11.0245 13.4998 9.99363 12.8581 9.36363L7.4248 4.02908"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeMiterlimit={10}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default ArrowRightV2;
